// src/app/components/preview/preview.component.ts
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { PreviewService } from '../../common/services/preview.service';

@Component({
  selector: 'app-preview',
  template: '<p>Loading preview...</p>',
  standalone: true
})
export class PreviewComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private previewService: PreviewService
  ) {}

  ngOnInit(): void {
    const secret = this.route.snapshot.queryParams['secret'];
    const slug = this.route.snapshot.queryParams['slug'];
    const status = this.route.snapshot.queryParams['status'];

    // console.log('Preview Component - Query Params:', {
    //   secret,
    //   slug,
    //   status,
    //   expectedSecret: environment.previewSecret
    // });

    // Validate secret
    if (secret !== environment.previewSecret) {
      console.error('Invalid preview secret');
      this.router.navigate(['/login']);
      return;
    }

    // console.log('Secret validated, enabling preview mode');

    this.previewService.enablePreviewMode();
    
    // Enable draft mode if status is draft
    if (status === 'draft') {
      this.previewService.enableDraftMode();
    } else {
      this.previewService.disableDraftMode();
    }

    // console.log('Redirecting to /preview/' + slug);

    // Redirect to the public preview route
    this.router.navigate(['/preview', slug]).then(success => {
      // console.debug('Navigation result:', success);
    });
  }
}